import type { WarehouseProduct } from '../types/inventory.types';

export interface InventoryRecordPricingTotals {
  totalCostPrice: number;
  totalSalePrice: number;
}

export function computeInventoryRecordPricingTotals(
  warehouseProducts?: WarehouseProduct[] | null,
): InventoryRecordPricingTotals {
  if (!warehouseProducts?.length) {
    return { totalCostPrice: 0, totalSalePrice: 0 };
  }

  return warehouseProducts.reduce(
    (totals, wp) => ({
      totalCostPrice: totals.totalCostPrice + Number(wp.pricing?.costPrice ?? 0),
      totalSalePrice: totals.totalSalePrice + Number(wp.pricing?.salePrice ?? 0),
    }),
    { totalCostPrice: 0, totalSalePrice: 0 },
  );
}
